/* eslint-disable no-unused-vars */

import { GraphQLObjectType, GraphQLID } from 'graphql';

// GraphQL Types
import UserType from './user.gql';
import ViewerType from './viewer.gql';
import CurriculumType from './curriculum.gql';
import CardType from './card.gql';
import ChannelType from './channel.gql';
import QuestionForReviewType from './questionForReview.gql';
import CourseType from './course.gql';
import Node from './node.gql';

// Helpers
import fetchLearnerCourse from '../../helper/LearningSpaceServices/fetchLearnerCourse';

module.exports = new GraphQLObjectType({
  name: 'Root',
  fields: () => ({
    learnerCourse: {
      type: CourseType,
      args: {
        id: {
          type: GraphQLID
        }
      },
      resolve: async (root, args) => fetchLearnerCourse(args.id)
    },
    viewer: {
      type: ViewerType,
      resolve: () => {
        console.log('Preview Offer!!');
        return {};
      }
    },
    node: Node.nodeField
  })
});
